import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  id: "show-flow-versions",
  class: "d-flex flex-fill list-page"
}
const _hoisted_2 = { class: "card border-0 background-fb" }
const _hoisted_3 = { class: "card-body padding-lrb-8" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_5 = { class: "d-flex flex-row justify-content-end align-items-center" }
const _hoisted_6 = { class: "d-flex flex-row align-items-center justify-content-center" }
const _hoisted_7 = { class: "d-flex align-items-center" }
const _hoisted_8 = { class: "btn-label" }
const _hoisted_9 = { class: "btn-text" }
const _hoisted_10 = { class: "d-flex flex-row align-items-center justify-content-center" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "el-dropdown-menu__item--divided" }, null, -1)
const _hoisted_12 = { class: "el-dropdown-menu__item d-flex justify-content-between align-items-center" }
const _hoisted_13 = { class: "loader-div-40" }
const _hoisted_14 = ["src"]

import {
  ElTable,
  ElTableColumn,
  ElDropdown,
  ElDropdownMenu,
  ElDropdownItem,
  ElButton,
  ElTooltip,
} from "element-plus";
import { onMounted, ref } from "vue";
import i18n from "@/core/i18n/i18n";
import {
  getFlowVersions,
  revertFlow,
  convertDate,
  getAIReportHistory,
  getAIReport,
  isAIFlowReportingEnabledForTenant,
} from "@/flow/services/flow.service";
import { currentRoute } from "@/core/router";
import { showConfirm } from "@/core/popup";
import { ASSETS_BASE_URL, DEFAULT_LOGO } from "@/core/logo";
import { faDownload } from "@fortawesome/free-solid-svg-icons";
import { authInfo } from "@/core/auth";


export default /*#__PURE__*/_defineComponent({
  __name: 'FlowVersions',
  props: {
    showClose: { type: Boolean }
  },
  emits: ["switch", "update-loading", "go-to-edit"],
  setup(__props: any, { emit: __emit }) {

const { t } = i18n.global;

const versionReportStatus = ref<Record<string, boolean>>({});
const selectedDownloadFormat = ref("pdf");
const isDownloading = ref(false);

const flowId = ref(currentRoute.value.params.id as string);

const headerStyle = ref({
  color: "#363636",
  borderBottomColor: "#a9d4fa",
  fontSize: "15px",
  fontWeight: "bolder !important",
  backgroundColor: "#fbfbfb",
});

const loadingFlows = ref(false);

const flowVersions = ref([]);

const rowStyle = ref({
  cursor: "pointer",
  backgroundColor: "#fbfbfb",
});

const props = __props;

const emit = __emit;

onMounted(async () => {
  getData();
});

async function downloadVersionReport(version: number, format: string) {
  if (!flowId.value) return;

  isDownloading.value = true;
  try {
    await getAIReport(flowId.value, format, version);
  } catch (e) {
    console.error(e);
  } finally {
    isDownloading.value = false;
  }
}

async function getData() {
  flowVersions.value = [];
  versionReportStatus.value = {};
  loadingFlows.value = true;

  try {
    const flowPromise = getFlowVersions(flowId.value);

    const tenantId = authInfo.value?.tenantId;
    const aiEnabled = tenantId
      ? await isAIFlowReportingEnabledForTenant(tenantId).catch((err) => {
          console.error("AI flow enable check failed:", err);
          return false;
        })
      : false;

    const aiHistoryPromise = aiEnabled
      ? getAIReportHistory(flowId.value).catch((err) => {
          console.error("AI report history fetch failed:", err);
          return null;
        })
      : Promise.resolve(null);

    const [flowResponse, aiHistoryResponse] = await Promise.all([
      flowPromise,
      aiHistoryPromise,
    ]);

    if (flowResponse) {
      flowVersions.value = flowResponse;
    }

    if (aiHistoryResponse && Array.isArray(aiHistoryResponse)) {
      aiHistoryResponse.forEach((report) => {
        const v = report.flow_version ?? report.version;
        if (v !== undefined && v !== null) {
          versionReportStatus.value[v] = true;
        }
      });
    }
  } catch (error) {
    console.error("Error fetching data:", error);
  } finally {
    loadingFlows.value = false;
  }
}

function switchVersion(row) {
  emit("switch", row.id, row.version);
}

async function flowRevert(id, version) {
  const isConfirmed = await showConfirm(
    "warning",
    "Revert Flow",
    "Are you sure revert to this version?"
  );
  if (isConfirmed) {
    emit("update-loading", true);
    const response = await revertFlow(id, version);
    if (response) {
      emit("switch", response.id, response.version);
    }
    emit("update-loading", false);
  }
}

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_unref(ElTable), {
          "header-cell-style": headerStyle.value,
          data: flowVersions.value.sort((a, b) => b.version - a.version),
          onRowClick: switchVersion,
          "row-style": rowStyle.value,
          "empty-text": loadingFlows.value ? ' ' : 'No Data',
          style: {"background-color":"#fbfbfb !important"},
          height: "98%"
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(ElTableColumn), {
              label: _unref(t)('Common.Name'),
              prop: "name",
              width: "auto"
            }, {
              default: _withCtx((scope) => [
                _createElementVNode("strong", null, _toDisplayString(scope.row.name), 1),
                _hoisted_4,
                _createTextVNode(" " + _toDisplayString(scope.row.description), 1)
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_unref(ElTableColumn), {
              label: _unref(t)('Flow.Steps'),
              width: "auto"
            }, {
              default: _withCtx((scope) => [
                _createTextVNode(_toDisplayString(scope.row.connectionSpecIdList
                  ? scope.row.connectionSpecIdList.filter(
                      (connectorSpecId) => connectorSpecId != null
                    ).length
                  : ""), 1)
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_unref(ElTableColumn), {
              label: _unref(t)('Common.CreationTime'),
              prop: "createdAt",
              width: "auto"
            }, {
              default: _withCtx((scope) => [
                _createTextVNode(_toDisplayString(_unref(convertDate)(scope.row.createdAt)), 1)
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_unref(ElTableColumn), {
              label: _unref(t)('Common.CreatedBy'),
              prop: "createdBy",
              width: "auto"
            }, {
              default: _withCtx((scope) => [
                _createTextVNode(_toDisplayString(scope.row.modifiedByName?.replace(/null/g, "").trim()), 1)
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_unref(ElTableColumn), {
              label: _unref(t)('Flow.Version'),
              prop: "version",
              width: "auto"
            }, {
              default: _withCtx((scope) => [
                _createTextVNode(_toDisplayString(scope.row.version), 1)
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_unref(ElTableColumn), { width: "180px" }, {
              header: _withCtx(() => [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    _createVNode(_unref(ElButton), {
                      disabled: loadingFlows.value,
                      id: "refresh-button",
                      onClick: _withModifiers(getData, ["stop"]),
                      class: "no-border btn-oneTeg-table-create btn-labeled",
                      size: "mini",
                      type: "primary"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("span", _hoisted_7, [
                          _createElementVNode("span", _hoisted_8, [
                            _createVNode(_component_font_awesome_icon, { icon: "redo-alt" })
                          ]),
                          _createElementVNode("span", _hoisted_9, _toDisplayString(_unref(t)("Common.Refresh")), 1)
                        ])
                      ]),
                      _: 1
                    }, 8, ["disabled"]),
                    (_ctx.showClose)
                      ? (_openBlock(), _createBlock(_unref(ElTooltip), {
                          key: 0,
                          effect: "custom",
                          content: _unref(t)('Common.Close'),
                          placement: "bottom"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_unref(ElButton), {
                              class: "no-border btn-link-icon",
                              size: "mini",
                              type: "primary",
                              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('go-to-edit'))),
                              "data-test": "activities-close-btn"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_font_awesome_icon, { icon: "times" })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["content"]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ]),
              default: _withCtx((scope) => [
                _createElementVNode("div", _hoisted_10, [
                  _createVNode(_unref(ElDropdown), { trigger: "click" }, {
                    dropdown: _withCtx(() => [
                      _createVNode(_unref(ElDropdownMenu), null, {
                        default: _withCtx(() => [
                          _createVNode(_unref(ElDropdownItem), {
                            onClick: _withModifiers(($event: any) => (
                          flowRevert(scope.row.id, scope.row.version)
                        ), ["stop"])
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_font_awesome_icon, {
                                icon: "history",
                                class: "margin-right-5"
                              }),
                              _createTextVNode(" " + _toDisplayString(_unref(t)("Flow.Revert")), 1)
                            ]),
                            _: 2
                          }, 1032, ["onClick"]),
                          (versionReportStatus.value[scope.row.version])
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _hoisted_11,
                                _createVNode(_unref(ElDropdown), {
                                  placement: "left-start",
                                  trigger: "hover",
                                  style: {"width":"100%"}
                                }, {
                                  dropdown: _withCtx(() => [
                                    _createVNode(_unref(ElDropdownMenu), null, {
                                      default: _withCtx(() => [
                                        _createVNode(_unref(ElDropdownItem), {
                                          onClick: _withModifiers(($event: any) => (
                                  downloadVersionReport(
                                    scope.row.version,
                                    'pdf'
                                  )
                                ), ["stop"])
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(" PDF Document ")
                                          ]),
                                          _: 2
                                        }, 1032, ["onClick"]),
                                        _createVNode(_unref(ElDropdownItem), {
                                          onClick: _withModifiers(($event: any) => (
                                  downloadVersionReport(
                                    scope.row.version,
                                    'docx'
                                  )
                                ), ["stop"])
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(" Word Document ")
                                          ]),
                                          _: 2
                                        }, 1032, ["onClick"]),
                                        _createVNode(_unref(ElDropdownItem), {
                                          onClick: _withModifiers(($event: any) => (
                                  downloadVersionReport(scope.row.version, 'md')
                                ), ["stop"])
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(" Markdown File ")
                                          ]),
                                          _: 2
                                        }, 1032, ["onClick"]),
                                        _createVNode(_unref(ElDropdownItem), {
                                          onClick: _withModifiers(($event: any) => (
                                  downloadVersionReport(
                                    scope.row.version,
                                    'json'
                                  )
                                ), ["stop"])
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(" JSON Data ")
                                          ]),
                                          _: 2
                                        }, 1032, ["onClick"])
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ]),
                                  default: _withCtx(() => [
                                    _createElementVNode("li", _hoisted_12, [
                                      _createElementVNode("span", null, [
                                        _createVNode(_component_font_awesome_icon, {
                                          style: {"color":"#606266"},
                                          icon: _unref(faDownload)
                                        }, null, 8, ["icon"]),
                                        _createTextVNode(" " + _toDisplayString(_unref(t)("Flow.Report")), 1)
                                      ]),
                                      _createVNode(_component_font_awesome_icon, {
                                        icon: "caret-left",
                                        style: {"margin-left":"10px","font-size":"12px","color":"#909399"}
                                      })
                                    ])
                                  ]),
                                  _: 2
                                }, 1024)
                              ], 64))
                            : _createCommentVNode("", true)
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_unref(ElButton), {
                        class: "no-border btn-oneTeg show-on-row-hover",
                        size: "mini",
                        type: "primary",
                        onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"]))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_font_awesome_icon, { icon: "cog" })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 2
                  }, 1024)
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["header-cell-style", "data", "row-style", "empty-text"])
      ])
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_13, [
      _createElementVNode("img", {
        src: `${_unref(ASSETS_BASE_URL)}/${_unref(DEFAULT_LOGO)}.png`,
        alt: "Loading...",
        class: "loader-logo-40"
      }, null, 8, _hoisted_14)
    ], 512), [
      [_vShow, loadingFlows.value]
    ])
  ]))
}
}

})